export const TIN_STATUS = 'tin/TIN_STATUS';
export const UPLOAD_DOCUMENT = 'tin/UPLOAD_DOCUMENT';
export const TIN_SUBMISSION = 'tin/TIN_SUBMISSION';
export const SET_DOCUMENT_ID = 'tin/SET_DOCUMENT_ID';
export const SET_DOCUMENT_LOADING = 'tin/SET_DOCUMENT_LOADING';
export const SET_TRACKING_NUMBER = 'tin/SET_TRACKING_NUMBER';
export const SET_SIGNATURE_CANVAS = 'tin/SET_SIGNATURE_CANVAS';
export const SAVE_AS_DRAFT = 'tin/SAVE_AS_DRAFT';
export const RETRIEVE_DRAFT = 'tin/RETRIEVE_DRAFT';
export const DELETE_SESSION = 'tin/DELETE_SESSION';
export const RETURN_TO_REGISTRATION = 'tin/RETURN_TO_REGISTRATION';
export const NPI_VALIDATIONS = 'tin/NPI_VALIDATIONS';
export const DISABLE_SAVEASDRAFT = 'tin/DISABLE_SAVEASDRAFT';
